/**
 * Retrieves url to use when adding a product to the cart
 *
 * @params {HTMLElement} element -Html element of add to cart button
 * @return {string} - The provided URL to use when adding a product to the cart
 */
const JS_HOOK_ADD_TO_CART_CONTAINER = '[js-hook-add-to-cart-container]';
const getAddToCartUrl = function(element) {
  const container = element.closest(JS_HOOK_ADD_TO_CART_CONTAINER);
  return container
    ? container.querySelector('.add-to-cart-url').value
    : document.querySelector('.add-to-cart-url').value;
};

export default getAddToCartUrl;
